import { render } from "./InquiryList.vue?vue&type=template&id=836d0590&scoped=true"
import script from "./InquiryList.vue?vue&type=script&lang=js"
export * from "./InquiryList.vue?vue&type=script&lang=js"

import "./InquiryList.vue?vue&type=style&index=0&id=836d0590&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-836d0590"]])

export default __exports__